var exports = {
  "k": "xf61da738--4a79ff--container",
  "Q": "xf61da738--4a79ff--content",
};

module.exports = exports;
